import React from 'react';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import { usePushContentControl } from 'features/layout/grid-panel/controls/GridPanelPushControl/usePushContentControl';

export const GridPanelPushControl = () => {
  const { controlEnabled, handleClick, label, tooltip } = usePushContentControl();

  if (!controlEnabled) {
    return null;
  }

  return (
    <GridPanelControl tooltip={tooltip} aria-label={label} icon="box-arrow" onClick={handleClick} />
  );
};
